import GoogleMapsApi from './GoogleMapsApi'
import {stylers} from './stylers'
import markerTmpl from './marker.tmpl'

/**
 * Location Map
 * Main map rendering function that uses our GMaps API class
 * @param {string} el - Google Map selector
 */
export function GMap(el, apiKey) {

  const gApiKey = apiKey
  const gmapApi = new GoogleMapsApi(gApiKey)
  const mapEl = document.querySelector(el)
  const data = {
    lat: parseFloat(mapEl.dataset.lat ? mapEl.dataset.lat : 0),
    lng: parseFloat(mapEl.dataset.lng ? mapEl.dataset.lng : 0),
    zoom: parseFloat(mapEl.dataset.zoom ? mapEl.dataset.zoom : 12),
  }
  // Call map renderer
  gmapApi.load().then(() => {
    renderMap(mapEl, data)
  })
}

/**
 * Render Map
 * @param {map obj} mapEl - Google Map
 * @param {obj} data - map data
 */
function renderMap(mapEl, data) {
  let markers = document.querySelectorAll('.marker')
  const options = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: stylers.styles,
    zoom: data.zoom,
    center: {
      lat: data.lat,
      lng: data.lng
    }
  }

  const map = new google.maps.Map(mapEl, options)

  if (markers) {
    map.markers = []
    let index = 0
    markers.forEach((marker) => {
      map.markers.push(marker);
      renderMarker(map, marker, mapEl, index)
      index++
    })
  }

  centerMap(map)
}

/**
 * Render Marker
 * Renders custom map marker and infowindow
 * @param map
 * @param {map element} mapEl
 * @param {object} data
 * @param index
 */
function renderMarker(map, data, mapEl, index) {
  const icon = {
    url: mapEl.dataset.marker,
    scaledSize: new google.maps.Size(40, 40)
  }

  const tmpl = markerTmpl(data.dataset)

  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(data.dataset.lat, data.dataset.lng),
    map: map,
    icon: icon,
    title:     data.dataset.title,
    content:   tmpl,
    animation: google.maps.Animation.DROP
  })
  let list = document.getElementById('markerList')
  list.insertAdjacentHTML('beforeend', '<div class= "linkage" id="p'+index+'">'+marker.content+'</div>')
  const infowindow = new google.maps.InfoWindow()

  handleMarkerClick(map, marker, infowindow, index)
}

/**
 * Handle Marker Click
 *
 * @param map
 * @param {marker} marker
 * @param infowindow
 * @param index
 */
var currentInfoWindow = null;
function handleMarkerClick(map, marker, infowindow, index) {
  document.querySelector('#p'+index).addEventListener("click", function() {
    if (currentInfoWindow != null) {
      currentInfoWindow.close();
    }
    infowindow.close(map, infowindow)
    infowindow.setContent(marker.content)
    infowindow.open(map, marker);
    currentInfoWindow = infowindow;
    document.getElementById('storemap').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  });

  google.maps.event.addListener(marker, 'click', function () {
    if (currentInfoWindow != null) {
      currentInfoWindow.close();
    }
    infowindow.close(map, infowindow)
    infowindow.setContent(marker.content)
    infowindow.open(map, marker)
    currentInfoWindow = infowindow;
  })

  google.maps.event.addListener(map, 'click', function (event) {
    if (infowindow) {
      infowindow.close(map, infowindow)
    }
  })
}

function centerMap(map) {
  let bounds = new google.maps.LatLngBounds()
  map.markers.forEach((marker, i) => {
    let latlng = new google.maps.LatLng(marker.dataset.lat, marker.dataset.lng);
    bounds.extend(latlng);
  })

  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
  } else {
    map.setCenter(bounds.getCenter());
  }
}
